/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Agent_Readiness_Check_Cli_Structured_OutputInputs */

const en_directory_agent_readiness_check_cli_structured_output = /** @type {(inputs: Directory_Agent_Readiness_Check_Cli_Structured_OutputInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Structured CLI output`)
};

const zh_directory_agent_readiness_check_cli_structured_output = /** @type {(inputs: Directory_Agent_Readiness_Check_Cli_Structured_OutputInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`命令行结构化输出`)
};

/**
* | output |
* | --- |
* | "Structured CLI output" |
*
* @param {Directory_Agent_Readiness_Check_Cli_Structured_OutputInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_agent_readiness_check_cli_structured_output = /** @type {((inputs?: Directory_Agent_Readiness_Check_Cli_Structured_OutputInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Agent_Readiness_Check_Cli_Structured_OutputInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_agent_readiness_check_cli_structured_output(inputs)
	return zh_directory_agent_readiness_check_cli_structured_output(inputs)
});
export { directory_agent_readiness_check_cli_structured_output as "directory.agent_readiness.check.cli_structured_output" }